import api from 'api';
import type { AccountPropertyRaw } from 'redux/modules/accounts.types';

export const AccountOnboardingApi = {
  get(): Promise<Array<AccountPropertyRaw>> {
    return api.get('account_onboarding.json');
  },
  save: (accountProperties: Array<AccountPropertyRaw>) => {
    return api.put('account_onboarding.json', { account_onboarding_properties: accountProperties });
  },
};
